export default __webpack_public_path__ + "static/media/creative_directions_xl.c64ea9d5.jpg";